import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41c66938"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "value value-box" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "value value-box" }
const _hoisted_9 = { class: "unit" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "amount" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "discount" }, null, -1))
const _hoisted_16 = { class: "code-b" }
const _hoisted_17 = { class: "v-code-vaild" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "input-wrapper" }
const _hoisted_21 = {
  key: 0,
  class: "inp-shade"
}

import { reactive, ref, defineExpose, computed, watch } from "vue-demi";
import { verifyCode } from "@/api/pay";
import { ElMessage } from "element-plus";
import i18n from "@/lang";
import { useStore } from "vuex";
import { BigNumber } from "bignumber.js";
import { staticTotal } from "@/utils";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props, { expose }) {

const route = useRoute();
if (
  route.fullPath == "/purchase-services?back_path=privilege" ||
  route.fullPath == "/privilege"
) {
  staticTotal("payOpen");
} else if (
  route.fullPath == "/purchase-services?back_path=personal" ||
  route.fullPath == "/userCenter/account"
) {
  staticTotal("renew");
}
const isChecked = ref(false);
const isShowVCode = ref(false);
const errorVaild = ref(false);
const params = reactive({
  singlePrice: 299,
  totalPrice: 0,
  vcode: "",
  num: 1,
  discount: 1,
  successMessage: "",
  type: "",
  vcodeType: 1,
  buyCountLimit: 0,
});
const $t = i18n.global.t;
const store = useStore();
const language = computed(() => store.state.appLanguage);
watch(
  () => store.state.pay.priceList,
  () => {
    updateTotalPrice();
  }
);
const updateTotalPrice = () => {
  if (params.vcodeType === 1) {
    if (params.num < 10) {
      params.singlePrice = language.value === "zh" ? 399 : 59;
    } else if (params.num >= 10 && params.num < 50) {
      params.singlePrice = language.value === "zh" ? 299 : 49;
    } else {
      params.singlePrice = language.value === "zh" ? 199 : 39;
    }
  }
  params.totalPrice = params.num * getCountSinglePrice();
  params.totalPrice = Math.round(params.totalPrice);
  if (isChecked.value) {
    let price = `${$t("user_center.money")}${getCountSinglePrice()}${$t(
        "user_center.device_months"
      )}`,
      limitText = "";
    const discountNumber = new BigNumber(params.discount);
    const initNumber = new BigNumber(100);
    if (params.discount < 1) {
      price =
        language.value === "zh"
          ? `${discountNumber.multipliedBy(10)}${$t("user_center.discount")}`
          : `${$t("user_center.discount")} ${initNumber.minus(
              discountNumber.multipliedBy(initNumber)
            )}%`;
    }
    if (params.buyCountLimit > 0) {
      limitText = `，${$t("user_center.limit_number")}${
        params.buyCountLimit
      }${$t("user_center.device_month1")}。`;
    }
    params.successMessage = `${$t(
      "user_center.verification_succeeded"
    )}${price}${limitText}`;
  }
};
const getCountSinglePrice = () => {
  const price = Math.round(params.discount * params.singlePrice);
  store.commit("pay/setPrice", price);
  return price;
};
const handlerVerifyCode = () => {
  if (!params.vcode) {
    ElMessage.error($t("user_center.please_v_code1"));
    return false;
  }
  handlerHideErrorValid();
  verifyCode({
    vcode: params.vcode,
  }).then((res: any) => {
    if (res.code == 0) {
      params.discount = res.data.discount;
      if (res.data.vcodeType === 2) {
        params.singlePrice = res.data.price;
        params.discount = 1;
        params.vcodeType = res.data.vcodeType;
        if (res.data.buyCountLimit < params.num) {
          params.num = res.data.buyCountLimit;
          ElMessage.warning(
            $t("v_code.buy_limit").replace("X", res.data.buyCountLimit)
          );
        }
      }
      params.buyCountLimit = res.data.buyCountLimit;
      params.type = "";
      isChecked.value = true;
      updateTotalPrice();
    } else if (["VEPD020", "VEPD021", "VEPD026"].includes(res.errorCode)) {
      errorVaild.value = true;
      params.successMessage = res.msg;
      params.type = "error";
    } else if (["VEPD022"].includes(res.errorCode)) {
      errorVaild.value = true;
      params.successMessage = res.msg;
      params.type = "warning";
    }
  });
};
const handlerHideErrorValid = () => {
  errorVaild.value = false;
  params.buyCountLimit = 0;
};
const handlerVerifyCodeCancle = () => {
  isChecked.value = false;
  params.vcodeType = params.discount = 1;
  updateTotalPrice();
};
expose({
  params,
  isChecked,
});

updateTotalPrice();

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)("user_center.current_price")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)("user_center.money")) + _toDisplayString(getCountSinglePrice()), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)("user_center.quantity")), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input_number, {
            onChange: updateTotalPrice,
            min: 1,
            max: 
              params.buyCountLimit > 0 && isChecked.value ? params.buyCountLimit : 999
            ,
            modelValue: params.num,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.num) = $event)),
            size: "small"
          }, null, 8, ["max", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)("user_center.device_month1")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref($t)("user_center.actual_amount")), 1),
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(_toDisplayString(_unref($t)("user_center.money")), 1),
        _createElementVNode("span", null, _toDisplayString(params.totalPrice), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", {
        class: "flex discount-flex",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowVCode.value = !isShowVCode.value))
      }, [
        _hoisted_15,
        _createTextVNode(" " + _toDisplayString(_unref($t)("v_code.discount_button_text")), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["v-code", { 'is-show-vcode': isShowVCode.value }])
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref($t)("user_center.v_code_velid")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_input, {
                modelValue: params.vcode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((params.vcode) = $event)),
                size: "small",
                placeholder: _unref($t)('user_center.please_v_code'),
                class: "w-auto"
              }, null, 8, ["modelValue", "placeholder"]),
              (isChecked.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                : _createCommentVNode("", true)
            ]),
            (!isChecked.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button",
                  onClick: handlerVerifyCode
                }, _toDisplayString(_unref($t)("user_center.use_v_code")), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button danger-button",
                  onClick: handlerVerifyCodeCancle
                }, _toDisplayString(_unref($t)("user_center.canel")), 1))
          ])
        ]),
        (isChecked.value || errorVaild.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["success-message", params.type])
            }, _toDisplayString(params.successMessage), 3))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})